module.exports = __webpack_public_path__ + "img/bg-ripple.171a9fe1.svg";